<template>
  <div class="industry1">
    <div class="industryTop">
      <div class="div1 flex">
        <p class="p1">校园</p>
        <img src="@/assets/image/行业/校园.png" />
      </div>
    </div>
    <div class="industryCenter">
      <p class="title">校园行业介绍</p>
      <div class="space-between">
        <p class="p1">
          为高校、中学、小学提高专业的新媒体宣传和管理平台，协助学校建立流程规范、资源统一的新媒体，融媒体平台。
        </p>
        <img src="@/assets/image/行业/校园图片.png" style="margin-left: 53px" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    window.document.title = "高校-湖南鼎太";
  },
};
</script>
<style lang="scss" scoped>
.industry1 {
  .industryTop {
    height: 231px;
    background-color: #3860f4;
    padding-top: 20px;
    .div1 {
      width: 1200px;
      margin: 0 auto;
      justify-content: space-between;
      .p1 {
        padding-top: 63px;
        font-size: 44px;
        font-family: PangMenZhengDao;
        font-weight: 400;
        font-style: italic;
        color: #ffffff;
        line-height: 50px;
      }
      img {
        padding-top: 19px;
      }
    }
  }
  .industryCenter {
    width: 1200px;
    margin: 98px auto 0 auto;
    padding-bottom: 126px;
    .title {
      font-size: 27px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #374567;
      line-height: 30px;
      text-align: center;
      padding-bottom: 79px;
    }
    .p1 {
      width: 512px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 300;
      color: #000;
      line-height: 32px;
      padding-top: 71px;
    }
  }
}
</style>
